/* KYME ACTIVE — suppress the Pop Convert popup while the cart drawer is
   open. Isolated in this file (and kyme-popup-suppress.css) on purpose:
   if the app is ever swapped or uninstalled, delete both files and the
   two tags loading them and nothing else in the theme is affected. */
(function () {
  'use strict';

  /* Verified in a real browser: the popup renders inside
     <div id="pop-convert-app" class="needsclick">, a direct child of
     <body>, full viewport width, height 0 until the popup fires. It is
     not a shopify-block-{id} wrapper, so the id does not regenerate —
     a direct lookup, not a substring guess. */
  var NON_RENDERED_TAGS = { SCRIPT: 1, STYLE: 1, LINK: 1, META: 1 };

  function isInHead(el) {
    var node = el;
    while (node) {
      if (node.tagName === 'HEAD') return true;
      node = node.parentElement;
    }
    return false;
  }

  /* Never tag an element that isn't rendered in the body flow. This is
     what should have caught the earlier bug (the substring fallback
     matched <script id="ck-pc-embed-script"> in <head>, display:none,
     0x0). getClientRects() is empty for display:none/contents/detached
     elements but still non-empty for a real, connected box even at
     height:0 — which #pop-convert-app legitimately is until the popup
     renders inside it — so this doesn't reject the real container. */
  function isValidPopupCandidate(el) {
    if (!el) return false;
    if (NON_RENDERED_TAGS[el.tagName]) return false;
    if (isInHead(el)) return false;
    if (!el.isConnected || el.getClientRects().length === 0) return false;
    return true;
  }

  function findPopupRoot() {
    var el = document.getElementById('pop-convert-app');
    return isValidPopupCandidate(el) ? el : null;
  }

  var tagged = null;

  function tag() {
    var root = findPopupRoot();
    if (!root || root === tagged) return;
    if (tagged) tagged.removeAttribute('data-kd-popup-target');
    root.setAttribute('data-kd-popup-target', '');
    tagged = root;
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    function sync() {
      document.body.classList.toggle('kd-popup-suppress', drawer.classList.contains('active'));
    }

    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function boot() {
    tag();
    watchDrawer();

    /* #pop-convert-app exists at load today, but keep re-checking anyway
       — a childList observer on body plus a bounded poll cost nothing,
       and cover the app changing when/how it injects the div later. */
    new MutationObserver(tag).observe(document.body, { childList: true });

    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      tag();
      if (tagged || attempts >= 40) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
